<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { Counters } from '@autobid/ui/types/components/CarsList'
import { useTypesWithCategories } from '@autobid/ui/composables/auction/useTypesWithCategories'
import { VEHICLE_TYPE_KEY } from '@autobid/ui/constants/VEHICLE_TYPE_KEY'
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'
import { computed, inject, watch } from 'vue'

interface Props {
  counters: Counters
}

const props = defineProps<Props>()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')

const useFilter = injectFilterComposable()
const {
  filters: { category },
} = useFilter()

const { typesWithCategories, categoriesNoFilterCounters }
  = useTypesWithCategories(auctionStrapiData?.type === 'carList' ? 'auction' : 'searchList')

const checkedAndDisabledIds = computed(() => {
  return typesWithCategories.value.reduce((acc: string[], el) => {
    const subCategoryIds = el.categories.reduce((subAcc: string[], subEl) => {
      const [typeId, categoryId] = String(subEl.id).split(';')

      const isDisabled = !props.counters?.[VEHICLE_TYPE_KEY]?.[typeId]?.category[categoryId]
      const isChecked = Boolean(category.value?.includes(String(subEl.id)))

      if (isChecked && isDisabled) {
        subAcc = [...subAcc, String(subEl.id)]
      }

      return subAcc
    }, [])

    acc = [...acc, ...subCategoryIds]

    return acc
  }, [])
})

function uncheckDisabledCategories() {
  if (!checkedAndDisabledIds.value.length)
    return

  category.value = category.value?.filter(
    el => !checkedAndDisabledIds.value.includes(el),
  )
}
watch(checkedAndDisabledIds, uncheckDisabledCategories)
</script>

<template>
  <common-filters-dropdown
    v-if="categoriesNoFilterCounters.atLeastOneExists"
    card-key="category"
  >
    <template #title>
      {{ $t('cars-list.filters.category') }}
    </template>

    <template #content>
      <div class="flex flex-col gap-6">
        <DynamicAuctionItemListFiltersCategoriesCategoryGroup
          v-for="typeData in typesWithCategories"
          :key="typeData.typeLabel"
          :type-label="typeData.typeLabel"
          :categories="typeData.categories"
          :counters="counters"
        />
      </div>
    </template>
  </common-filters-dropdown>
</template>
